export async function openEdgeSession(cfDomain, token) {
  try {
    await fetch(`https://${cfDomain}/edge/session/${token}`, {
      method: "GET",
      mode: "cors",
      credentials: "include",          // IMPORTANT for cookies on cross-origin
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.log("Error in edge session", error);
  }
}

